export type Market = {
  _id: string
  name: string
  betfairId?: string
  isSuspended?: boolean
  ballChalu?: boolean
  betDelay?: number | string
  skySession?: boolean
  parkerSession?: boolean
  skySessioneventid?: string
  [key: string]: unknown
}

export type RateItem = {
  rateNo: string
  rateBack?: number
  rateLay?: number
  [key: string]: unknown
}

export type RunItem = { runs: number; [key: string]: unknown }

export type SubMarket = {
  _id: string
  marketId: string
  name: string
  markets?: string
  betfairId?: string
  status?: boolean | string
  fancyCommission?: boolean
  ballChalu?: boolean
  isSuspended?: boolean
  isMarketSuspended?: boolean
  isAbandon?: boolean
  isSky?: boolean
  isParker?: boolean
  order?: string | number
  betDelay?: number | string
  minBet?: number | string
  maxBet?: number | string
  maxLimitsType?: string
  maxMarketAmountFancy?: number | string
  suspendMaxLimit?: number | string
  notification?: string
  horseBack?: number
  horseLay?: number
  rateBack?: number
  rateLay?: number
  runButtonValue?: number
  rateCategoryId?: string
  rateCategoryName?: string | { _id: string; name: string }
  resultLogs?: unknown[]
  [key: string]: unknown
}

export type SubMarketBundle = {
  subMarketShow: Market
  subMarketDetails: SubMarket
  rateList: RateItem[]
  runList: RunItem[]
}

export const MAX_LIMIT_OPTIONS = ['Minor', 'Minor1', 'Medium', 'Medium1', 'Major', 'Major1'] as const
